module.exports = __webpack_public_path__ + "static/img/12.9608a18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/12.png
// module id = Tsz1
// module chunks = 0